import React from 'react'
import {Row, Col, Typography} from 'antd'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import typo from "../../../constants/dictionaries";
import MiningQuantityForm from '../MiningQuantity'
import {RowTableDetail, TableDetail} from "../../Common/View/TableViewDetail";
import HangMucTableView from '../../CongTrinh/HangMuc/View'
import FileDinhKemView from '../../CongTrinh/FileDinhKem/View'
import helper from "../../../helper/helper";
import TTKT from "../../AttachTable/TTKT/Table";
import TCQKTSD from "../../AttachTable/TCQKTSD/Table";
import constant from '../../../constants/constant'
import ThamSoHC from "../../AttachTable/ThamSoHC/View";

const {Text} = Typography;

const ConstructionInfo = ({congTrinh, loaiCT, thanhTraKiemTra, tienCapQuyen, hoSoXinCapPheps}) => {
  const {
    tenDVHC,
    diaDiem,
    tenCongTrinh,
    mucDichKTSD,
    luuLuongKT,
    luongNuocKhaiThac,
    nguonNuocKTSD,
    cheDoKhaiThac,
    phuongThucKhaiThac,
    thuocSong,
    thuocLVS,
    luuLuongXaDongChayMin,
    luuLuongKhaiThacMax,
    mucNuocDangBinhThuong,
    mucNuocCaoNhatTruocLu,
    luuLuongXaDongChayToiThieu,
    congSuatLapMay,
    luuLuongKhaiThacLonNhat,
    luuLuongLonNhatQuaNMTD,
    mucNuocChet,
    mucNuocDonLu,
    dungTichHuuIch,
    dungTichToanBo,
    hangMucs = [],
    tsHoChuas
  } = congTrinh || {};


  return (
    <Row gutter={50}>
      <Col>
        <Row>
          <TableDetail>
            <RowTableDetail title={typo.cscore_license_construction}>{tenCongTrinh}</RowTableDetail>
            <RowTableDetail title={typo.cscore_license_mining_location}>{diaDiem}</RowTableDetail>
            <RowTableDetail title={typo.cscore_license_purpose}>{mucDichKTSD}</RowTableDetail>
            {/*<RowTableDetail title={typo.cscore_luuLuongKhaiThac}>{luuLuongKT}</RowTableDetail>*/}
            <RowTableDetail title={typo.cscore_luongNuocKhaiThac}>{luongNuocKhaiThac}</RowTableDetail>
            <RowTableDetail title={typo.cscore_license_mining_mode}>{cheDoKhaiThac}</RowTableDetail>
            <RowTableDetail title={typo.cscore_license_mining_method}>{phuongThucKhaiThac}</RowTableDetail>
            <RowTableDetail title={typo.cscore_license_resource}>{nguonNuocKTSD}</RowTableDetail>
            <RowTableDetail title={typo.cscore_thuocSong}>{thuocSong}</RowTableDetail>
            <RowTableDetail title={typo.cscore_thuocLVS}>{thuocLVS}</RowTableDetail>
            {loaiCT === constant.DICT_LOAI_CT.NM_HOCHUA &&
            <>
              <RowTableDetail title={typo.cscore_luuLuongXaDongChayToiThieu}>{luuLuongXaDongChayMin}</RowTableDetail>
              <RowTableDetail title={typo.cscore_luuLuongKhaiThacLonNhat}>{luuLuongKhaiThacMax}</RowTableDetail>
              <RowTableDetail title={typo.cscore_dungTichHuuIch}>{dungTichHuuIch}</RowTableDetail>
              <RowTableDetail title={typo.cscore_dungTichToanBo}>{dungTichToanBo}</RowTableDetail>
            </>}

            {loaiCT === constant.DICT_LOAI_CT.NM_THUYDIEN &&
            <>
              <RowTableDetail title={typo.cscore_congSuatLapMay}>{congSuatLapMay}</RowTableDetail>
              <RowTableDetail title={typo.cscore_luuLuongMaxQuaNMTD}>{luuLuongLonNhatQuaNMTD}</RowTableDetail>
              <RowTableDetail title={typo.cscore_luuLuongXaDongChayToiThieu}>{luuLuongXaDongChayToiThieu}</RowTableDetail>
              <RowTableDetail title={typo.cscore_dungTichHuuIch}>{dungTichHuuIch}</RowTableDetail>
              <RowTableDetail title={typo.cscore_dungTichToanBo}>{dungTichToanBo}</RowTableDetail>
            </>}

            {(loaiCT === constant.DICT_LOAI_CT.NM_THUYDIEN || loaiCT === constant.DICT_LOAI_CT.NM_HOCHUA) &&
            <>
              <RowTableDetail title={typo.cscore_mucNuocChet}>{mucNuocChet}</RowTableDetail>
              <RowTableDetail title={typo.cscore_mucNuocDonLu}>{mucNuocDonLu}</RowTableDetail>
              <RowTableDetail title={typo.cscore_mucNuocDangBinhThuong}>{mucNuocDangBinhThuong}</RowTableDetail>
              <RowTableDetail title={typo.cscore_mucNuocCaoNhatTruocLu}>{mucNuocCaoNhatTruocLu}</RowTableDetail>
            </>}
          </TableDetail>
        </Row>
      </Col>
      {/* <Col span={12}>
        <a>{helper.generateIndexForLabel(typo.cscore_hangMucCongTrinh, 3.1)} </a>
        <HangMucTableView dataSource={hangMucs || []}/>
        <div className="mt-20"/>
        <a>{helper.generateIndexForLabel(typo.cscore_tcqktsd, 3.2)} </a>
        <TCQKTSD dataSource={tcqs || []} mode="presentation"/>
        <div className="mt-20"/>
        <a>{helper.generateIndexForLabel(typo.cscore_ttkt, 3.3)} </a>
        <TTKT mode="presentation" dataSource={ttkts || []}/>
        <div className="mt-20"/>
        <a>{helper.generateIndexForLabel(typo.cscore_fileDinhkem, 3.4)} </a>
        <FileDinhKemView mode="presentation" dataSource={hoSoXinCapPheps || []}/>
        <div className="mt-20"/>
        <a>{helper.generateIndexForLabel(typo.cscore_thamSoHC, 3.4)} </a>
        <ThamSoHC mode="presentation" dataSource={tsHoChuas || []}/>
      </Col> */}
    </Row>
  )
};

ConstructionInfo.propTypes = {
  congTrinh: PropTypes.any.isRequired,
  loaiCT: PropTypes.number.isRequired
};

export default connect()(ConstructionInfo)